module.exports = MaterialUI.SwipeableDrawer;